export default __webpack_public_path__ + "static/media/GillSans.0c3ea264.otf";